import { render, staticRenderFns } from "./SalesRecapTransactionSummary.vue?vue&type=template&id=f942d60c&"
import script from "./SalesRecapTransactionSummary.vue?vue&type=script&lang=js&"
export * from "./SalesRecapTransactionSummary.vue?vue&type=script&lang=js&"
import style0 from "./SalesRecapTransactionSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports